import { Badge, type BadgeTone } from "@/components/ui/badge";
import type { ApiKeyStatus } from "@/api";
import { useTranslation } from "@/i18n";
import type { TranslationKey } from "@/i18n";

const STATUS_TONE: Record<ApiKeyStatus, BadgeTone> = {
  active: "success",
  disabled: "warning",
  revoked: "danger",
  expired: "neutral",
};

// API key lifecycle states map to translation keys so the badge
// re-renders on a locale switch.
const STATUS_KEY: Record<ApiKeyStatus, TranslationKey> = {
  active: "apiKeys.status.active",
  disabled: "apiKeys.status.disabled",
  revoked: "apiKeys.status.revoked",
  expired: "apiKeys.status.expired",
};

export function ApiKeyStatusBadge({ status }: { status: ApiKeyStatus }) {
  const { t } = useTranslation();
  return <Badge tone={STATUS_TONE[status]}>{t(STATUS_KEY[status])}</Badge>;
}
